import { isNeuropsychEvaluationProgram } from '@lyrahealth-inc/shared-app-logic/src/features/programConfigs/programHelpers'
import { Episode, EpisodeStates } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'

import { ROLES } from '../../../common/constants/appConstants'
import { hasRole } from '../../../common/utils/utils'

export const ASYNC_TIME_NOTE_NAME = 'npAsyncTimeNote'

const PSYCHOMETRIST_ROLES = [ROLES.LT_NP_PSYCHOMETRIST, ROLES.DA_NP_PSYCHOMETRIST]
export const LICENSED_NP_ROLES = [
  ROLES.LT_NP_NEUROPSYCHOLOGIST,
  ROLES.DA_NP_NEUROPSYCHOLOGIST,
  ROLES.LT_NP_TESTING_PSYCHOLOGIST,
  ROLES.DA_NP_TESTING_PSYCHOLOGIST,
]
// Only psychometrists and NP/TPs author billable async time; care coordinators do not.
const ASYNC_TIME_NOTE_AUTHOR_ROLES = [...PSYCHOMETRIST_ROLES, ...LICENSED_NP_ROLES]

// Secondary UX layer only: the server enforces the same cutoff. Entries stay open through the
// post-discharge window because the episode remains in_progress until the deferred closure runs.
export const isEpisodeClosedForAsyncTime = (state: EpisodeStates | undefined): boolean =>
  !!state && state !== EpisodeStates.IN_PROGRESS

export const canAuthorAsyncTimeNote = ({
  isNPTestingEnabled,
  episode,
  roles,
}: {
  isNPTestingEnabled?: boolean
  episode?: Pick<Episode, 'program_name' | 'state'>
  roles: string[]
}): boolean =>
  !!isNPTestingEnabled &&
  !!episode &&
  isNeuropsychEvaluationProgram(episode.program_name) &&
  !isEpisodeClosedForAsyncTime(episode.state) &&
  hasRole(roles, ASYNC_TIME_NOTE_AUTHOR_ROLES)

// Form context for the template's activity type select. Only a Neuropsychologist or Testing Psychologist can bill
// Evaluation & Interpretation Services: everyone else gets Test Administration & Scoring only.
export const getAsyncTimeNoteExternalValues = (roles: string[]): Record<string, string[]> =>
  hasRole(roles, LICENSED_NP_ROLES) ? {} : { allowedActivityTypes: ['Test Administration & Scoring'] }
